import type { MainNavRoute, MainPath } from '../types';

import PERMISSIONS from '@snowit/utilities/permissions';

import { makeChildren } from '../utils';

export const VenuesPath: MainPath = '/venues/:id?/:section?';

export const VENUES_TABS = ['info', 'warehouse', 'request'] as const;
export type VenuesTabs = (typeof VENUES_TABS)[number];

export const VenuesRoute: MainNavRoute = {
  path: '/venues',
  label: 'routes.venues',
  icon: 'venue',
  type: 1,
  permissions: [PERMISSIONS.VENUES__LIST],
  // hidden: true,
  children: [
    {
      path: ':id',
      permissions: [PERMISSIONS.VENUES__DETAILS],
      children: makeChildren<VenuesTabs>({
        info: { path: 'info' },
        warehouse: { path: 'warehouse', permissions: [PERMISSIONS.VENUES__WAREHOUSE_VIEW] },
        request: { path: 'request', permissions: [PERMISSIONS.VENUES__WAREHOUSE_VIEW] },
      }),
    },
  ],
  kb: 'https://doc.clickup.com/20614177/p/h/kn311-24161/dd87a30651af922',
};
